import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import DiagramProps from './DiagramProps'
import KendoDiagramConnection from '../KendoDiagramConnection'
import KendoDiagramShape from '../KendoDiagramShape'

import ConnectionDefaults from './ConnectionDefaults'
import Editable from './Editable'
import Layout from './Layout'
import Pannable from './Pannable'
import Pdf from './Pdf'
import Selectable from './Selectable'
import ShapeDefaults from './ShapeDefaults'

export default {
    props: DiagramProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        ConnectionDefaults,
        Editable,
        Layout,
        Pannable,
        Pdf,
        Selectable,
        ShapeDefaults,
    ],
    mounted() {
        this._resolveChildren()
        this.setInnerDataSource('connectionsDataSourceRef', 'connectionsDataSource')
        kendo.jQuery(this.$el).kendoDiagram(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDiagram()
        },
        _resolveChildren() {
            this.resolveChildren('connections', KendoDiagramConnection.name)
            this.resolveChildren('shapes', KendoDiagramShape.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-diagram-vue-wrapper/src/KendoDiagram/KendoDiagramMixin.js